import { ErrorBoundary, init as sentryInit, setTag } from '@sentry/react';
import React, { FunctionComponent, PropsWithChildren, useEffect } from 'react';
import UnhandledErrors from './pages/empty/UnhandledErrors';
import { useEnvironmentVariables } from '../lib/contexts/environmentContext';

const GlobalErrorHandler: FunctionComponent<PropsWithChildren<unknown>> = ({ children }) => {
    const { sentryDsn, environmentType } = useEnvironmentVariables();

    useEffect(() => {
        sentryInit({
            dsn: sentryDsn,
            environment: environmentType,
            beforeBreadcrumb(breadcrumb, hint) {
                if (hint?.event && (breadcrumb?.category === 'ui.click' || breadcrumb?.category === 'ui.input')) {
                    const { target } = hint.event;
                    if (target?.outerHTML) {
                        breadcrumb.message = target.outerHTML;
                    }
                }
                return breadcrumb;
            },
            ignoreErrors: [
                'Non-Error promise rejection captured with value',
                'Cannot redefine property: googletag',
                'Failed to load the JS script of the agent',
            ],
            denyUrls: [
                // Chrome extensions
                /chrome-extension:\/\//i,
                /extensions\//i,
                /^chrome:\/\//i,
                // Safari extensions
                /safari-extension:\/\//i,
                /safari-web-extension/i,
            ],
        });
        setTag('instance', window.PlatformAdapter.instance.name);
    }, [sentryDsn, environmentType]);

    if (environmentType !== 'development') {
        return <ErrorBoundary fallback={<UnhandledErrors />}>{children}</ErrorBoundary>;
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
};

export default GlobalErrorHandler;
